import React, {useState,useEffect} from 'react'

import { XIcon } from '@heroicons/react/outline'
import { useSelector } from 'react-redux'
import {selectUser} from '../features/userSlice'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import Parse from 'parse/dist/parse.min.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'


export default function CategoryMenu() {
  const user = useSelector(selectUser)
  const [loadingBtn, setLoadingBtn] = useState(false)
  const [listCategory, setListCategory] = useState([])
  const [selectedCategory, setSelectedCategory] = useState("")
  const [loading, setLoading] = useState(false)


  

  const formik = useFormik({
    initialValues: {
      categoryName:'',     
    },
    validationSchema: Yup.object({
      categoryName: Yup.string(),
       }),
    onSubmit: async (data) => {  
    setLoadingBtn(true) 
    listCategory.push(data.categoryName)
    const newListsCategory = new Parse.Query('ListGeneres')
    let queryNewListsCategory = await newListsCategory.get('0e7sJk6CSC')

    queryNewListsCategory.set('categoriaMenu',listCategory)

    try {
      await queryNewListsCategory.save()
      setLoadingBtn(false)
    } catch (error) {
      console.log(error)
    }
     
            
    }
  })

  
  useEffect(() => {
    (async () => {
      setLoading(true)
               let paserQueryGeneres = new Parse.Query('ListGeneres');         
         try {                     
            let generes = await paserQueryGeneres.get('0e7sJk6CSC');               
            setListCategory(generes.get('categoriaMenu')) 
            setLoading(false)           
            return true
        } catch (error) {  
          setLoading(false)             
           return false;
        }            
       })()
}, [])

if(loading) {
  return(
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center mb-20">
   
    <main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
    <div className="mt-6 grid grid-cols-1 gap-y-4 gap-x-2 sm:grid-cols-2 lg:grid-cols-10 xl:gap-x-1">
   
      <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
    <span className="hidden sm:block">
      <div
        type="button"
        className=" animate-pulse inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm   bg-slate-400  w-20 h-7"
     />     
    </span>
 
  </div>
       </main>
       </div>
  )
}

  if(!user) {
    return(
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center mb-20">

<main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
         <div className="sm:text-center ">
           <h1 className="text-6xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-8xl">
             <span className="block xl:inline">:( ¡Opp! Área Restringida</span>{' '}
             <span className="block text-cyan-600 xl:inline">Solo para usuarios Budgie</span>
           </h1>           
       
         </div>
       </main>

 </div> 
    )
}






  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 items-center mb-20">
   
    <main className="mt-5 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-8 lg:mt-10 lg:px-8 xl:mt-18">
  
    <h2 className="text-2xl font-medium tracking-tight text-gray-900">Categorías Gatronómicas</h2>

                            <div className="mt-6 grid grid-cols-1 gap-y-4 gap-x-2 sm:grid-cols-2 lg:grid-cols-6 xl:gap-x-5">
                              {listCategory.map((categoryMenu) => (
                                <span className="hidden sm:block">
                                <button
                                  type="button"
                                  className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-full shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
                                >
                                  <XIcon className="-ml-1 mr-2 h-5 w-5 text-gray-500" aria-hidden="true" />
                                 {categoryMenu}
                                </button>
                              </span>
                              ))}
                            </div>


                            <div>
        <div className="md:grid md:grid-cols-3 md:gap-6 mt-10">
          <div className="md:col-span-1">
            <div className="px-4 sm:px-0">
              <h3 className="text-lg font-medium leading-6 text-gray-900">Nueva Categoría de Menú</h3>
              <p className="mt-1 text-sm text-gray-600">
              Esta información se mostrará públicamente.
              </p>
            </div>
          </div>
          <div className="mt-5 md:mt-0 md:col-span-2">
            <form action="#" method="POST" onSubmit={formik.handleSubmit}>
              <div className="shadow sm:rounded-md sm:overflow-hidden">
                <div className="px-4 py-5 bg-white space-y-6 sm:p-6">
                <div className="col-span-6 sm:col-span-3">
                      <label htmlFor="categoryName" className="block text-sm font-medium text-gray-700">
                        Nombre de la Categoría
                      </label>
                      <input
                        type="text"
                        name="categoryName"                        
                        id="categoryName"
                        value={formik.values.categoryName}
                        onChange={formik.handleChange}
                        autoComplete="given-name"
                        className="mt-1 focus:ring-cyan-500 focus:border-cyan-500 block border w-full h-8 p-4 shadow-sm sm:text-sm border-gray-400 rounded-md"
                      />
                    </div>                           
               
                </div>

                 <div>
            
                 </div>


                <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
               
                  <button
                    type="submit"
                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
                  >
                     { loadingBtn &&
               <span className=" items-center pr-3  ">
                 <FontAwesomeIcon icon={faSpinner} size='lg' className='animate-spin' />
                 </span>}
                   Crear Categoría
                  
                   
                  </button>
              
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>            
                    
           </main>
   
     </div>
  )
}
